export enum LocationHelpKind {
  BLOCKED = 'blocked',
  UNAVAILABLE = 'unavailable',
  APPROXIMATE = 'approximate',
}

export enum LocationHelpOS {
  IOS = 'ios',
  ANDROID = 'android',
  MACOS = 'macos',
  WINDOWS = 'windows',
  OTHER = 'other',
}

export enum LocationHelpPlatform {
  IOS_SAFARI = 'ios_safari',
  IOS_SAFARI_LEGACY = 'ios_safari_legacy',
  IOS_PWA = 'ios_pwa',
  IOS_APP_BROWSER = 'ios_app_browser',
  IOS_IN_APP = 'ios_in_app',
  ANDROID_CHROME = 'android_chrome',
  ANDROID_SAMSUNG = 'android_samsung',
  ANDROID_FIREFOX = 'android_firefox',
  ANDROID_PWA = 'android_pwa',
  DESKTOP_CHROME = 'desktop_chrome',
  DESKTOP_EDGE = 'desktop_edge',
  DESKTOP_FIREFOX = 'desktop_firefox',
  DESKTOP_SAFARI = 'desktop_safari',
  UNKNOWN = 'unknown',
}

// Phones report a few metres with GPS and tens of metres indoors on Wi-Fi.
// "Approximate" location comes back as kilometres.
export const APPROXIMATE_ACCURACY_M = 1500;
// One coarse reading can be a cold start; a second one this much later means
// the phone is only handing out approximate location.
export const APPROXIMATE_CONFIRM_MS = 10_000;
